<template>
  <div class="block py-12 article-products">
    <div class="flex mb-56 sm:mb-70 -mx-24 sm:mx-0">
      <ProductSpot 
        v-for="(product, index) in sortProducts"
        v-if="!isSeller || product.brandName === 'Ullmax'"
        :key="product.itemId"
        :product="product"
        :index="index"
        :bgcolor="getBgColor(index)"
        :list-title="componentTitle"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import ProductSpot from '~/components/productlist/ProductSpot.vue';
import type ComponentBlock from '~/models/component-block';
import Product from '~/models/product';
import type { WpProduct } from '~/constants/types/product';
import { getBgColor } from '~/util/styles';
const { fetchProducts } = useProductService();
const isSeller = useCookie<boolean>('isSeller', { maxAge: 3600 * 24 * 182, path: '/' });

const props = defineProps<{
  component: ComponentBlock,
}>();

const componentTitle = computed(()=>{
  return props.component.title || props.component.layout || 'ArticleProducts';
});

const products = ref<Product[]>([]);

onMounted(async()=> {
  const ids = props.component.data.products.map(p => p.ecom_id);
  if (ids.length) {
    const res = await fetchProducts({
      products: ids,
    });
    if (res) {
      console.log(res);
      products.value = res.products.map(p => new Product({ contentData: null, ecomData: p }));
    } else {
      console.error();
    }
  }
});

const sortProducts = computed(()=> {
  const output = [] as Product[];
  const productsIn = props.component.products as WpProduct[];
  productsIn.forEach((i) => {
    const thisProduct = products.value.find(
      (f) => f.ecomId === Number(i.ecom_id)
    );
    if (thisProduct) {
      output.push(thisProduct);
    }
  });

  return output;
});

</script>
